import { withStyles } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import ProjectItem from "../../ProjectItem";

function ProjectSliders(props) {
  const { projects, classes } = props;

  const renderProjectItem = () => {
    if (projects && projects.length > 0) {
      return projects.map(item => {
        return <ProjectItem key={item.id} item={item} />;
      });
    }
  };

  return <div className={classes.container}>{renderProjectItem()}</div>;
}

export default withStyles(styles)(ProjectSliders);
